<template>
  <button
    :type="buttonType"
    class="button"
    :disabled="loading"
    :class="{
      'button--secondary': secondary,
      'button--big': big,
      'button--wide': wide,
      'button--small': small,
      'button--finished': doneLoading,
      'button--loading': loading,
    }"
    @click="event"
  >
    <IconCheckmark
      v-if="(doneLoading && !loading) || (doneLoading && !async)"
      class="icon icon--green layout--margin-right-xxs"
    />
    <spring-spinner
      v-if="loading"
      class="layout--inline-block layout--margin-right-sm"
      :animation-duration="1500"
      :size="21"
      :color="'#b6bbff'"
      transition="fade"
      mode="out-in"
      :duration="1000"
      enter-active-class="enter-active"
    />
    {{ currentLabel }}
  </button>
</template>

<script>
import IconCheckmark from "../assets/icons/iconCheckmark.svg";

export default {
  name: "loading-button",
  props: {
    event: { type: Function, default: () => {} },
    buttonType: { type: String, default: "button" },
    secondary: Boolean,
    big: Boolean,
    wide: Boolean,
    small: Boolean,
    loading: Boolean,
    async: { type: Boolean, default: true },
    doneLoading: Boolean,
    label: { type: String, default: "Save" },
    loadingLabel: { type: String, default: "Saving..." },
    doneLoadingLabel: { type: String, default: "Saved!" },
  },
  components: { IconCheckmark },
  computed: {
    currentLabel: function() {
      if (this.doneLoading && !this.loading) {
        return this.doneLoadingLabel;
      }
      if (this.loading) {
        return this.loadingLabel;
      }
      return this.label;
    },
  },
};
</script>

<style></style>
